import { useState } from "react";
import {
  ArrowRight,
  Search,
  MonitorPlay,
  Gamepad2,
  Package,
  ShoppingBag,
  ChartNoAxesCombined,
  CalendarDays,
  Mic,
  Video,
  Globe,
  X,
} from "zudoku/icons";
import { products, sections } from "./products.js";
import { SiteFooter } from "./SiteFooter.js";
import { SiteHeader } from "./SiteHeader.js";
import "./docs-overview.css";

const icons = {
  live: MonitorPlay,
  voice: Mic,
  "one-to-one": Video,
  overseas: Globe,
  "game-companion": Gamepad2,
  rental: Package,
  commerce: ShoppingBag,
  quant: ChartNoAxesCombined,
  booking: CalendarDays,
};
const categories = [
  "全部产品",
  ...new Set(products.map((product) => product.category)),
];
const catalog = products.map((product) => ({
  ...product,
  icon: icons[product.id as keyof typeof icons],
  family: product.name,
  status: product.status || (!product.ready ? "资料整理中" : ""),
}));

export const DocsOverview = () => {
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("全部产品");
  const matches = catalog.filter(
    (item) =>
      (category === "全部产品" || item.category === category) &&
      [
        item.name,
        item.family,
        item.description,
        item.category,
        ...item.tags,
        "功能介绍 系统演示 技术框架",
      ]
        .join(" ")
        .toLowerCase()
        .includes(query.trim().toLowerCase()),
  );
  return (
    <div className="ax-portal ax-doc-hub">
      <title>文档中心 · 安象科技</title>
      <SiteHeader />
      <main>
        <section className="ax-catalog-hero">
          <div className="ax-container">
            <span className="ax-catalog-eyebrow">安象产品与服务</span>
            <h1>产品文档中心</h1>
            <p>了解产品能力，体验业务场景，查阅技术文档</p>
            <label className="ax-catalog-search">
              <Search size={20} />
              <input
                aria-label="搜索产品文档"
                placeholder="搜索产品名称或业务场景"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
              />
              {query && (
                <button
                  type="button"
                  aria-label="清除搜索"
                  onClick={() => setQuery("")}
                >
                  <X size={18} />
                </button>
              )}
            </label>
            <div className="ax-catalog-quick">
              <span>快捷入口</span>
              <a href="/products/live-social">
                社交娱乐产品体系 <ArrowRight size={13} />
              </a>
              <a href="/products/operations">
                公共运营能力 <ArrowRight size={13} />
              </a>
            </div>
          </div>
        </section>
        <div className="ax-catalog-nav-wrap">
          <nav className="ax-container ax-catalog-nav" aria-label="产品分类">
            {categories.map((item) => (
              <button
                type="button"
                key={item}
                aria-pressed={category === item}
                onClick={() => setCategory(item)}
              >
                {item}
              </button>
            ))}
            <a href="/support">
              产品咨询 <ArrowRight size={14} />
            </a>
          </nav>
        </div>
        <div className="ax-container ax-catalog-body">
          <div className="ax-catalog-heading">
            <h2>{query ? "搜索结果" : category}</h2>
            <span role="status">{matches.length} 个产品</span>
          </div>
          <div className="ax-catalog-grid">
            {matches.map((item) => {
              const Icon = item.icon;
              return (
                <article className="ax-catalog-card" key={item.id}>
                  <div className="ax-catalog-card-meta">
                    <span>
                      {item.category}
                      {item.family !== item.name && ` / ${item.family}`}
                    </span>
                    {item.status && <small>{item.status}</small>}
                  </div>
                  <div className="ax-catalog-card-title">
                    <Icon size={28} strokeWidth={1.5} />
                    <h3>
                      <a href={`/${item.id}/features`}>{item.name}</a>
                    </h3>
                  </div>
                  <p>{item.description}</p>
                  <div className="ax-catalog-card-links">
                    {sections.map((section) => (
                      <a
                        key={section.slug}
                        aria-label={`${item.name} · ${section.label}`}
                        href={`/${item.id}/${section.slug}`}
                      >
                        {section.label}
                        <ArrowRight size={12} />
                      </a>
                    ))}
                  </div>
                </article>
              );
            })}
          </div>
          {!matches.length && (
            <div className="ax-catalog-empty">
              <Search size={30} />
              <h3>没有找到相关产品</h3>
              <p>换个关键词试试，或查看全部产品文档。</p>
              <button
                type="button"
                onClick={() => {
                  setQuery("");
                  setCategory("全部产品");
                }}
              >
                查看全部产品
              </button>
            </div>
          )}
          <div className="ax-catalog-help">
            <div>
              <h3>需要进一步了解产品？</h3>
              <p>联系产品顾问，获取演示环境、功能清单与交付说明。</p>
            </div>
            <a href="/support">
              联系咨询 <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};
